<!-- INSURANCE TYPE PRIMENG TABLE -->
<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true" dataKey="code"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'tableManagement.insurance.insuranceTypeManagement' | translate }}
    </div>
  </ng-template>
  <!-- #endregion TABLE TITE DEFINITION -->

  <!-- #region TABLE COLUMN DEFINITION-->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>

      <!-- NAME -->
      <th pSortableColumn='name'>
        <div class='d-flex align-items-center h-100'>

          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'general.name' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='name'></p-sortIcon>
            <p-columnFilter field='name' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- ACTIVE -->
      <th pSortableColumn="disabled">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.active' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="disabled"></p-sortIcon>
            <p-columnFilter field="disabled" type="boolean" display="menu"
            [showApplyButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

    </tr>
  </ng-template>
  <!-- #endregion TABLE COLUMN DEFINITION-->

  <!-- #region TABLE BODY -->
  <ng-template pTemplate="body" let-InsuranceType>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(InsuranceType)">

      <!-- SELECT -->
      <td>
        <div class="d-flex justify-content-center">
          <p-tableCheckbox [value]="InsuranceType"></p-tableCheckbox>
        </div>
      </td>

      <!-- NAME -->
      <td>
        {{ InsuranceType.name }}
      </td>

      <!-- ACTIVE -->
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
            [ngClass]="{'true-icon pi-check-circle': !InsuranceType.disabled, 'false-icon pi-times-circle': InsuranceType.disabled}">
          </i>
        </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE BODY -->

  <!-- #region TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE EMPTY MESSAGE -->

  <!-- #region TABLE FOOTER-->
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="4" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">

          <!-- ADD accessory BUTTON -->
          <app-table-add-button [text]=" 'tableManagement.insurance.insuranceType' | translate"
          (btnClick)="create()"></app-table-add-button>

          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="selectedEntities.length === 0"></app-table-change-status-button>

          <div  class="d-flex flex-row " style="margin-left: auto;">

            <!-- TABLE EXCEL BUTTON -->
            <app-table-excel-button class="buttonTableExcel"  (btnClick)="exportExcel()"></app-table-excel-button>
          </div>
          <!--<app-table-excel-button class="buttonTableExcel"  (btnClick)="exportExcel()"></app-table-excel-button> -->
        </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE FOOTER -->

</p-table>

<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
  <div>
    <app-change-status-shared [items]=" 'tableManagement.insurance.insuranceTypes' | translate " [display]="true"
      [service]=accessorieservice [entitiesList]=selectedEntities (return)="refreshList($event)"
    (close)="closeStatusDialog($event)"></app-change-status-shared>
  </div>
}

<!-- INSURANCE TYPE FORM -->
<app-InsuranceType-form></app-InsuranceType-form>

